import { PspContext } from "@/config/contexts";
import { useContext } from "react";

export function useAttendanceNoteDialog() {
  const { lang } = useContext(PspContext);
  return { lang };
}
